const adminOptions = {
  showDeletedTitle: 'Admin Features',
  showDeleted: 'Show only Deleted Equipments',
  showDeletedChipLabel: 'Deleted Equipments',
};

export default adminOptions;